  <template>

    <div class="page">
    		<div class="gridheader">
    			<div class="row wrapper">
    				<div class="col-md-4 title">
              <h1 class="mrgn">{{$t('PROTETICS')}}</h1>
              <ul class="list-unstyled">
    						<li v-bind:class="(category == 'fixed') ? 'active' : ''"><a v-on:click.prevent="category = 'fixed'" href="#">{{ $t('FIXED')}}</a></li>
    						<li v-bind:class="(category == 'mobile') ? 'active' : ''"><a v-on:click.prevent="category = 'mobile'" href="#">{{ $t('MOBILE')}}</a></li>
                <li v-bind:class="(category == 'other') ? 'active' : ''"><a v-on:click.prevent="category = 'other'" href="#">{{ $t('OTHER')}}</a></li>
    					</ul>
            </div>
    				<div class="col-md-8 action">
              <a v-on:click="addProtetic" class="btn btn-primary"><img src="../assets/img/user-plus.svg" alt=""> {{$t('ADDPROTETIC')}}</a>
              <a href="#" v-on:click.prevent="resetProtetics" class="btn btn-white"><img src="../assets/img/user-plus.svg" alt=""> {{$t('RESETTODEFAULTPROTETICS')}}</a>
            </div>
    			</div>
    		</div>
        <div class="gridheader secondary" v-if="category == 'fixed'">
          <div class="row">
            <div class="col-md-12 title">{{$t('IMPLANTCOMPONENTS')}} <b-form-checkbox v-model="implantchecked" class="grey">{{$t('SHOW')}}</b-form-checkbox></div>
          </div>
        </div>
    		<div class="row">
          <div class="table-responsive">
      			<table class="maintable">
      				<thead>
      					<tr>
      						<td>{{$t('NAME')}}</td>
      						<td>{{$t('SHORTNAME')}}</td>
      						<td>{{$t('ACTIVATION')}}</td>
                  <td>{{$t('ACTIONS')}}</td>
      					</tr>
      				</thead>
      				<tbody>
      					<tr v-for="protetic in filteredprotetics">
      						<td>{{protetic.name}}</td>
      						<td><span class="shortname-type minwidth" v-bind:style="'background-color: '+(protetic.color)+';'">{{protetic.shortname}}</span></td>
      						<td><span class="switch" v-on:click="toogleActivation(protetic)" v-bind:class="(protetic.active == 1) ? 'on' : 'off'"></span></td>
                  <td><a href="#" class="grid-action" v-on:click.prevent="deleteProtetic(protetic.proteticId)"><img src="../assets/img/icon-trash.svg" alt=""></a><a href="#" class="grid-action" v-on:click.prevent="editProtetic(protetic)"><img src="../assets/img/cell-edit.svg" alt=""></a></td>
      					</tr>
      				</tbody>
      			</table>
          </div>
    		</div>

        <b-pagination align="center" v-if="protetics.totalCount > 20" :total-rows="protetics.totalCount" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>

        <b-modal ref="newprotetic" id="newprotetic" v-bind:ok-title="$t('SAVE')" v-bind:cancel-title="$t('CANCEL')" v-on:ok="saveProtetic" v-bind:title="$t('NEWPROTETIC')">
      			<form method="get" action="">
      				<div class="col-12">
      					<div class="form-group row" v-bind:class="(formError.notice && formError.notice.name) ? 'has-danger' :''">
      						<label>{{ $t('NAME')}}</label>
      						<input type="text" v-model="formData.name" class="form-control secondary" v-bind:placeholder="$t('NAME')">
                  <div v-if="formError.notice && formError.notice.name" class="form-control-feedback">{{formError.notice.name}}</div>
      					</div>
      				</div>
              <div class="col-12">
      					<div class="form-group row" v-bind:class="(formError.notice && formError.notice.shortname) ? 'has-danger' :''">
      						<label>{{ $t('SHORTNAME')}}</label>
      						<input type="text" v-model="formData.shortname" class="form-control secondary" v-bind:placeholder="$t('SHORTNAME')">
                  <div v-if="formError.notice && formError.notice.shortname" class="form-control-feedback">{{formError.notice.shortname}}</div>
      					</div>
      				</div>
              <div class="col-12">
      					<div class="form-group row">
      						<label>{{ $t('COLOR')}}</label>
      					</div>
                <div class="form-group row" v-bind:class="(formError.notice && formError.notice.color) ? 'has-danger' :''">
                  <chrome-picker :value="formData.color" @input="updateColorValue"></chrome-picker>
                  <div v-if="formError.notice && formError.notice.color" class="form-control-feedback">{{formError.notice.color}}</div>
      					</div>
      				</div>
              <div class="col-12">
      					<div class="form-group row" v-bind:class="(formError.notice && formError.notice.category) ? 'has-danger' :''">
      						<label>{{ $t('CATEGORY')}}</label>
      						<select class="form-control secondary" v-model="formData.category">
                    <option value="fixed">{{$t('FIXED')}}</option>
                    <option value="mobile">{{$t('MOBILE')}}</option>
                    <option value="other">{{$t('OTHER')}}</option>
                  </select>
                  <div v-if="formError.notice && formError.notice.category" class="form-control-feedback">{{formError.notice.category}}</div>
      					</div>
      				</div>
              <div class="col-12" v-if="formData.category == 'fixed'">
      					<div class="form-group row" v-bind:class="(formError.notice && formError.notice.implant) ? 'has-danger' :''">
      						<b-form-checkbox v-model="formData.implant" class="grey">{{$t('IMPLANT')}}</b-form-checkbox>
                  <div v-if="formError.notice && formError.notice.implant" class="form-control-feedback">{{formError.notice.implant}}</div>
      					</div>
      				</div>
              <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
              <div class="clearfix"></div>
      			</form>
        </b-modal>

    	</div>



  </template>

  <script>

  import { mapActions, mapGetters } from 'vuex'
  import { Chrome } from 'vue-color'
  import proteticsApi from '@/api/protetics'

  export default {
    components:
    {
      'chrome-picker': Chrome
    },
    name: 'Protetics',
    data: function()
    {
      return {
        query: '',
        category: 'fixed',
        implantchecked: false,
        protetics: {},
        formData: {
          id: '',
          name: '',
          shortname: '',
          color: '',
          category: '',
          implant: ''
        },
        formError:
        {

        },
        pagination:
        {
          query: '',
          currentPage: 1,
          limit: 20
        }
      };
    },
    created: function()
    {
      this.getProtetics();
    },
    methods:
    {
      addProtetic: function(data)
      {
        var me = this;
        me.formData = {
          id: '',
          name: '',
          shortname: '',
          color: '',
          category: '',
          implant: ''
        };
        me.$refs.newprotetic.show()
      },
      getProtetics: function()
      {
        var me = this;
        proteticsApi.getProtetics({}, function(data)
        {
          if(data.error && data.error == true)
          {
            Vue.$notify.error(data.notice);
            return;
          }
          me.protetics = data;
        });
      },
      saveProtetic: function(bvEvt)
      {
        var me = this;

        bvEvt.preventDefault();

        proteticsApi.saveProtetic(me.formData, function(val)
        {
          if(val.error)
          {
            me.formError = val;
          }
          else
          {
            me.formError = {};
            me.formData = {
              id: '',
              name: '',
              shortname: '',
              color: '',
              category: '',
              implant: false
            };
            me.$refs.newprotetic.hide()
            me.getProtetics();
          }
        })
      },
      deleteProtetic: function(id)
      {
        var me = this;
        me.$store.commit('setModalAlert',
        {
          text: me.$i18n.t('AREYOUSHURE'),
          btnAction: function()
          {
            proteticsApi.deleteProtetic({id: id}, function(data)
            {
              if(data.error && data.error == true) me.$notify.error(data.notice);
              else me.$notify.success(data.notice);
              me.getProtetics();
            })
          }
        })
      },
      editProtetic: function(data)
      {
        var me = this;
        data = Object.assign({}, data, {});
        data.id = data.proteticId;
        me.formData = data;
        me.$refs.newprotetic.show()
      },
      updateColorValue: function(val)
      {
        var me = this;
        me.formData.color = val.hex;
      },
      toogleActivation: function(protetic)
      {
        var me = this;
        proteticsApi.saveProtetic({id: protetic.proteticId, active: ((protetic.active == 1) ? 0 : 1)}, function(data)
        {
          if(data.error && data.error == true) me.$notify.error(data.notice);
          else me.$notify.success(data.notice);
          me.getProtetics();
        })
      },
      resetProtetics: function()
      {
        var me = this;
        me.$store.commit('setModalAlert',
        {
          text: me.$i18n.t('AREYOUSHURE'),
          btnAction: function()
          {
            proteticsApi.resetProtetics({}, function(data)
            {
              if(data.error && data.error == true) me.$notify.error(data.notice);
              else me.$notify.success(data.notice);
              me.getProtetics();
            })
          }
        })
      }
    },
    watch:
    {
      query: function()
      {
        var me = this;
        me.getProtetics();
      },
      category: function(val)
      {
        var me = this;
        me.getProtetics();
      },
      'pagination.currentPage': function(newValue, oldValue)
      {
        var me = this;
        me.getProtetics();
      }
    },
    computed:
    {
      getParams: function()
      {
        var me = this;
        var data = Object.assign({}, me.pagination, {});
        data.start = (data.currentPage-1)*data.limit;
        return data;
      },
      filteredprotetics: function()
      {
        var me = this;

        var out = [];
        if(me.protetics.root)
        {
          for(var i=0;i<me.protetics.root.length;i++)
          {
            var protetic = me.protetics.root[i];
            if(protetic.category == me.category)
            {
              if(me.category == 'fixed')
              {
                if(me.implantchecked != protetic.implant) continue;
              }
              out.push(protetic);
            }
          }
        }

        return out;
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/Protetics.vue